import { Navigate } from "react-router-dom";
import { canAccessQariPortal } from "./hifzAuth";

/** Guards qari/admin routes using token + role from state or localStorage */
export default function ProtectedQariRoute({ hifzUser, children }) {
  if (!canAccessQariPortal(hifzUser)) {
    return <Navigate to="/hifz-login" replace />;
  }
  return children;
}
